import React, { useState, useEffect, useRef } from 'react'
import {
  withStyles,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
import { useSelector } from 'react-redux'
import styles from './styles'

const SeoSettings = props => {
  const { classes, onSave, initialSettings } = props
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )

  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings || {} : collectionSettings || {}

  const [keywords, setKeywords] = useState('')
  const [description, setDescription] = useState('')
  const [indexGoogle, setIndexGoogle] = useState('yes')

  useEffect(() => {
    const sourceData = initialSettings || landingPageData

    if (sourceData) {
      const possibleDescKeys = [
        'description',
        'seoDescription',
        'metaDescription',
        'pageDescription',
        'setDescription',
      ]

      const descKey = possibleDescKeys.find(key => sourceData[key])
      if (descKey) setDescription(sourceData[descKey])

      // Initialize keywords if available
      if (sourceData.seoKeywords) {
        setKeywords(sourceData.seoKeywords)
      }

      const indexableValue =
        sourceData.seoIndexable !== undefined
          ? sourceData.seoIndexable
          : sourceData.indexable !== undefined
          ? sourceData.indexable
          : sourceData.indexGoogle !== undefined
          ? sourceData.indexGoogle === 'yes'
          : true

      setIndexGoogle(indexableValue === true ? 'yes' : 'no')
    }
  }, [landingPageData, initialSettings])

  const handleKeywordsChange = e => {
    const newValue = e.target.value
    setKeywords(newValue)

    // Always call onSave if it exists
    if (onSave) {
      onSave({
        ...(initialSettings || {}),
        seoKeywords: newValue,
      })
    }
  }

  const handleDescriptionChange = e => {
    const newValue = e.target.value
    setDescription(newValue)

    // Always call onSave if it exists
    if (onSave) {
      onSave({
        ...(initialSettings || {}),
        seoDescription: newValue,
      })
    }
  }

  const handleIndexGoogle = event => {
    const newValue = event.target.value
    setIndexGoogle(newValue)

    // Always call onSave if it exists
    if (onSave) {
      onSave({
        ...(initialSettings || {}),
        seoIndexable: newValue === 'yes',
      })
    }
  }

  // Input label props to prevent the floating behavior
  const inputLabelProps = {
    shrink: false,
    style: {
      position: 'relative',
      transform: 'none',
      fontSize: '14px',
      marginBottom: '8px',
    },
  }

  return (
    <div className={classes.container}>
      <Typography
        fontSize="16px"
        fontWeight={400}
        fontFamily="Inter"
        className={classes.header}
      >
        SEO settings
      </Typography>

      <div className={classes.section}>
        <div>
          <Typography fontSize="14px" fontWeight={500} fontFamily="Inter">
            Seo description
          </Typography>
          <CoreTextField
            multiline
            maxRows={3}
            minRows={3}
            fullWidth
            marginTop={false}
            value={description || ''}
            onChange={handleDescriptionChange}
            placeholder="Seo description"
            variant="outlined"
            size="medium"
            InputLabelProps={inputLabelProps}
            label={null} // Remove the label entirely
          />
          <div className={classes.helperText}>
            Appears in search results and social share posts. Max 320 characters
          </div>
        </div>
      </div>
      <div className={classes.section}>
        <div>
          <Typography fontSize="14px" fontWeight={500} fontFamily="Inter">
            Keywords
          </Typography>
          <CoreTextField
            fullWidth
            multiline
            maxRows={2}
            minRows={2}
            marginTop={false}
            value={keywords || ''}
            onChange={handleKeywordsChange}
            placeholder="keyword, keyword, keyword"
            variant="outlined"
            size="medium"
            InputLabelProps={inputLabelProps}
            label={null} // Remove the label entirely
          />
          <div className={classes.helperText}>Separate keywords by commas.</div>
        </div>
      </div>
      <div className={classes.section}>
        <div>
          <div className={classes.label}>Index to Google</div>
          <FormControl component="fieldset">
            <RadioGroup row value={indexGoogle} onChange={handleIndexGoogle}>
              <FormControlLabel
                value="yes"
                control={<Radio color="primary" />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio color="primary" />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(SeoSettings)
